import _defineProperty from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/objectSpread2.js";
var _objectSpread2;
import tr_json from './tr.json';
export default _objectSpread((_objectSpread2 = {
  route: {
    dashboard: '首页',
    home: '首页',
    system: '系统管理'
  },
  navbar: {
    logOut: '退出登录',
    profile: '个人资料',
    updatePwd: '修改密码',
    dashboard: '首页',
    github: '项目地址',
    screenfull: '全屏',
    theme: '换肤',
    size: '布局大小'
  },
  login: {
    title: 'OKEY',
    errorAccount: '请输入5到32位的数字和字母',
    errorPassword: '密码至少位5位',
    logIn: '登录',
    username: '账号',
    password: '密码',
    capCode: '验证码'
  },
  button: {
    add: '添加',
    edit: '修改',
    delete: '删除',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    cancel: '取消',
    clear: '清除',
    back: '返回',
    export: '导出',
    save: '保存',
    approve: '审批'
  },
  common: {
    mustSelectOne: '请选中操作项!',
    deleteConfirm: '你确认删除该记录？',
    tooltip: '提示',
    warning: '警告',
    optionSuccess: '操作成功',
    uploadError: '上传文件失败',
    isRequired: '不能为空',
    week: {
      mon: '周一',
      tue: '周二',
      wed: '周三',
      thu: '周四',
      fri: '周五',
      sat: '周六',
      sun: '周日'
    }
  },
  shop: {
    shopName: "店铺名称",
    测试: "1111111111",
    活动标题: "活动标题",
    店铺: "店铺",
    活动内容: "活动内容",
    操作: "操作",
    查看: "查看",
    设备: "设备",
    预约消息: "预约消息",
    预约人: "预约人",
    预约状态: "预约状态",
    待确认: "待确认",
    已确认: "已确认",
    已取消: "已取消"
  },
  店铺名称: "店铺名称",
  店铺LOGO: "店铺Logo",
  店铺地址: "店铺地址",
  营业开始时间: "营业开始时间",
  营业结束时间: "营业结束时间",
  联系电话: "联系电话",
  是否营业中: "是否营业中",
  管理员: "管理员",
  营业执照: "营业执照",
  商铺详情: "商铺详情",
  操作: "操作",
  查看: "查看",
  修改: "修改",
  删除: "删除",
  查看详情: "查看详情",
  手机号已经存在: "Telefon numarası zaten mevcut, lütfen başka bir numara girin",
  添加店铺: "Mağaza Ekle",
  "无归属人": "Sahipsiz",
  "历史归宿人": "Önceki Sahip",
  "历史归属人": "Tarihi sahibi",
  "有": "Var",
  "无": "Yok",
  "有无归属人": "Sahip Var mı/Yok mu",
  "正在运营店铺": "Faaliyette Olan Mağazalar",
  "全部撤机店铺": "Tüm Kapatılan Mağazalar",
  "未成交线索": "Sonuçlanmamış İpucu",
  "结算差额": "Kesim Farkı",
  "店铺余额": "Mağaza Bakiyesi",
  "结算单支付差额": "Ödeme Faturası Farkı",
  //7.30
  OKR目标: "OKR Hedefi",
  "父任务(履约期目标)": "Üst Görev (Sözleşme Dönemi Hedefi)",
  "子目标": "Alt Hedef",
  "经理名称": "Yönetici Adı",
  "代理子账号": "Vekil Alt Hesap",
  "履约日期": "Sözleşme Tarihi",
  "履约状态": "Sözleşme Durumu",
  "履约中": "Sözleşme Devam Ediyor",
  "已锁号": "Numara Kilitlendi",
  "新建目标": "Yeni Hedef Oluştur",
  "子账号": "Alt Hesap",
  "签约日期": 'Sözleşme Tarihi',
  "履约期设备数": "Sözleşme Dönemi Cihaz Sayısı",
  "进度": "İlerleme",
  "目标": "Hedef",
  "已签约铺设": "Sözleşmesi İmzalanan Kurulum",
  "目标名称": "Hedef Adı",
  "目标名称不能为空": "Hedef adı boş olamaz",
  "目标接收角色": "Hedefin Atanacağı Rol",
  "销售经理": "Satış Müdürü",
  "运维经理": "Operasyon Müdürü",
  "履约期目标时间": "Sözleşme Dönemi Hedef Süresi",
  "新建线索数": "Yeni İpucu Sayısı",
  "履约设备数": "Sözleşme Cihaz Sayısı",
  "目标生成方式": "Hedef Oluşturma Yöntemi",
  "父目标分解(履约期任务)": "Üst Hedefin Ayrıştırılması (Sözleşme Dönemi Görevi)",
  "子目标时间": "Alt Hedef Süresi",
  "受账单结算周期影响，一周可能存在跨月情况，比如7月第5周跨7月和8月，所以以逻辑月为依据判断": "Fatura döngüsünden etkilendiği için, bir hafta aylar arası olabilir. Örneğin Temmuz’un 5. haftası hem Temmuz hem Ağustos’a girebilir, bu nedenle mantıksal aya göre değerlendirilir.",
  "履约期": "Sözleşme Dönemi",
  "锁号/已完成": "Numara Kilitli / Tamamlandı",
  "签约设备数": "Sözleşmeli Cihaz Sayısı",
  "单台运营时长": "Tek Cihaz Çalışma Süresi",
  "合同签约后的6个月开始，在任务执行期": "Sözleşme imzalandıktan 6 ay sonra, görev yürütme döneminde",
  "已完成代表在履约期内任务已完成，达到指定的履约设备数，比如要求100，实际≥100个": "‘Tamamlandı’ demek, sözleşme döneminde görev tamamlandı ve belirtilen cihaz sayısına ulaşıldı. Örneğin hedef 100, gerçekleşen ≥100.",
  "已锁号代表在履约期内任务未完成，比如要求100，实际完成60": "‘Numara kilitlendi’ demek, sözleşme döneminde görev tamamlanmadı. Örneğin hedef 100, gerçekleşen 60.",
  "请选择一条信息": "Lütfen bir bilgi seçin",
  "延长履约期": "Sözleşme Süresini Uzat",
  "代理员工名称": "Vekil Çalışan Adı",
  "履约效期": "Sözleşme Geçerlilik Süresi",
  "yctip": "Uzatıldıktan sonra, uzatma süresinde işletmenin sipariş vermesine ve kurulum yapmasına izin verilir",
  "上调履约设备数": "Sözleşme Cihaz Sayısını Artır",
  "分解目标": "Hedefi Ayrıştır",
  "最高目标数": "Maksimum Hedef Sayısı",
  "已完成次数": "Tamamlanan Sayısı",
  "完成率": "Tamamlanma Oranı",
  "子目标完成情况": "Alt Hedeflerin Durumu",
  "确定延长履约期": "Sözleşme süresini uzatmayı onayla???",
  "修改履约设备数": "Sözleşme Cihaz Sayısını Değiştir",
  "创建子账号": "Alt Hesap Oluştur",
  "履约完成状态": "Sözleşme Tamamlama Durumu",
  "确定修改履约设备数": "Sözleşme cihaz sayısını değiştirmeyi onayla",
  "履约期目标时间不能为空": "Sözleşme hedef süresi boş olamaz",
  "履约设备数不能为空": "Sözleşme cihaz sayısı boş olamaz",
  "子账号不能为空": "Alt hesap boş olamaz",
  "提交成功": "Başarıyla gönderildi",
  "请选择": "Lütfen seçiniz",
  "选择月": "Ay Seç",
  "子目标时间不能为空": "Alt hedef süresi boş olamaz",
  "新建线索数详情": "Yeni İpucu Sayısı Detayı",
  "子目标日期": "Alt Hedef Tarihi",
  "目标数": "Hedef Sayısı",
  "完成情况": "Tamamlanma Durumu",
  "线索名称": "İpucu Adı",
  "线索电话": "İpucu Telefonu",
  "线索地址": "İpucu Adresi",
  "拜访状态": "Ziyaret Durumu",
  "编辑新建线索数目标": "Yeni İpucu Sayısı Hedefini Düzenle",
  "当前单台运营时长/小时": "Mevcut Tek Cihaz Çalışma Süresi / Saat",
  "编辑签约设备数目标": "Sözleşmeli Cihaz Sayısı Hedefini Düzenle",
  "编辑单台运营时长目标": "Tek Cihaz Çalışma Süresi Hedefini Düzenle",
  "签约设备数详情": "Sözleşmeli Cihaz Sayısı Detayı",
  "单台运营时长详情": "Tek Cihaz Çalışma Süresi Detayı",
  "WAIT_VISITE": "Ziyaret Bekleniyor",
  "IN_DISCUSSION": "Görüşme Devam Ediyor",
  "HAVE_INTENTION": "İlgileniyor",
  "DONE_DEAL": "Sözleşme Kabul Edildi",
  "DECLINED": "Reddedildi",
  "地址": "Adres",
  "小时": "Saat",
  "新建线索数不能为空": "Yeni ipucu sayısı boş olamaz",
  "签约设备数不能为空": "Sözleşmeli cihaz sayısı boş olamaz",
  "单台运营时长不能为空": "Tek cihaz çalışma süresi boş olamaz",
  "关联子账号": "Bağlı Alt Hesap",
  "跟进次数": "Takip Sayısı",
  "合同编码": "Sözleşme Kodu",
  "合同类型": "Sözleşme Türü",
  "所属组织": "Bağlı Organizasyon",
  "购买": "Satın Alma",
  "租赁": "Kiralama",
  "新建线索数导出xlsx": "Yeni İpucu Sayısı - dışa aktar.xlsx",
  "签约设备数导出xlsx": "Sözleşmeli Cihaz Sayısı - dışa aktar.xlsx",
  "单台运营时长导出xlsx": "Tek Cihaz Çalışma Süresi - dışa aktar.xlsx",
  "父任务导出xlsx": "Üst Görev - dışa aktar.xlsx",
  "子目标单台运行时长": "Alt Hedef Tek Cihaz Çalışma Süresi",
  "子任务线索数总和不能大于任务线索数": "Alt görevlerin ipucu toplamı, görev ipucu sayısını aşamaz",
  "子任务设备数总和不能大于任务设备数": "Alt görevlerin cihaz toplamı, görev cihaz sayısını aşamaz",
  "线索存量上限设置": "İpucu Stok Üst Sınır Ayarı",
  "单个销售专员线索上限数量设置": "Bir Satış Temsilcisi için İpucu Üst Sınır Ayarı",
  "温馨说明：设置上限后，则所有销售专员无法超额新建线索；注意：不包含已签约开户的线索，不涉及子账号业务": "Not: Üst sınır ayarlandıktan sonra, tüm satış temsilcileri belirtilen sınırı aşarak yeni ipucu oluşturamaz. Dikkat: İmzalanmış ve açılmış ipuçları dahil değildir, alt hesaplarla ilgili değildir.",
  "单个销售专员线索上限数量设置不能为空": "Satış temsilcisi için ipucu üst sınırı boş olamaz",
  "合同编号": "Sözleşme Numarası",
  "签约金额": "Sözleşme Tutarı",
  "合同导出xlsx": "Sözleşme - dışa aktar.xlsx"
}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, "\u6B63\u5728\u8FD0\u8425\u5E97\u94FA", "Faaliyette Olan Mağazalar"), "\u5168\u90E8\u64A4\u673A\u5E97\u94FA", "Tüm Kapatılan Mağazalar"), "\u672A\u6210\u4EA4\u7EBF\u7D22", "Sonuçlanmamış İpucu"), "合同下单时间", "Sözleşme Sipariş Zamanı"), "设备安装时间", "Cihaz Kurulum Zamanı"), "合同状态", "Sözleşme Durumu"), "httip", "İmzalandı: Sözleşmenin imzalanması, sözleşme dosyasının yüklendiğini ifade eder\n\n" + "İşbirliği Devam Ediyor: Sözleşme yüklenmiş, siparişin kurulumu bekleniyor;\n\n" + "İşbirliği Tamamlandı: Sözleşme yüklenmiş, cihazlar kurulmuştur;"), "运转分析", "Çalışma Analizi"), "总数", "Toplam"), "选择运维", "Operasyon Seçimi"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_objectSpread2, "设备运转良好，暂无空转记录", "Cihaz düzgün çalışıyor, boşta çalışma kaydı yok"), "店铺设备数据详情", "Mağaza Ekipman Verisi Detayı"), "查看明细", "Detayları Görüntüle"), "请输入部门名称", "Lütfen bölüm adını giriniz")), tr_json);